import React from 'react';
import { getStatusBadgeClass } from '../../utils/helpers';

export default function StatusBadge({ status, size = 'md' }) {
  return (
    <span className={`status-badge ${getStatusBadgeClass(status)}`}>
      {status?.replace(/_/g, ' ').toUpperCase()}
    </span>
  );
}
